module.exports = __webpack_public_path__ + "fonts/1814282f17baadf118fab0780d33517a.woff";